


















































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {CustomerServiceParams} from "../../params";
import {CommonStatus} from "@/enums/status";
import {Component, Watch} from "vue-property-decorator";
import debounce from "lodash/debounce";
import {CustomerServiceStore} from "@/modules/customerservice/store";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeType} from "@/enums/type";
import {RoleDeclare} from "@/enums/roledeclare";
@Component({
    name: "CustomerServiceSearch",
    components: {EmployeeSelector, EnumSelector, DistrictSelector, ProvinceSelector, MillisecondDatePicker}
})
export default class extends mixins(CommonMixin) {
    params = new CustomerServiceParams();
    CommonStatus = CommonStatus;
    EmployeeType = EmployeeType;
    
    @Watch("params", { deep: true })
    onchangeParams(val: any) {
        this.handleChangeParams(val);
    }
    
    handleChangeParams = debounce((val: any) => {
        const params = {...val, page: 1};
        CustomerServiceStore.updateParams(params);
        CustomerServiceStore.listCustomerService(params);
    }, 500)
}
